import { render, staticRenderFns } from "./sentiment.md?vue&type=template&id=a85ece10&"
import script from "./sentiment.md?vue&type=script&lang=js&"
export * from "./sentiment.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports